// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__ijzg0","mask":"style_mask__Mduvo","text":"style_text__OeQfB"};